import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface CountryIdFormFieldProps {}

export const CountryIdFormField: React.FC<CountryIdFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ country_id: number }>()

  const api = useApi()

  const query = useQuery({
    queryKey: ['static/countries'],
    queryFn: () => api.misc.getCountries(),
  })

  const countries = useMemo(() => {
    const items = (query.data ?? []).map((i) => ({ ...i, value: i.value.toString() }))
    return sortAlphabeticallyByKey(items, 'label')
  }, [query.data])

  return (
    <FormField
      name="country_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Country</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              loading={query.isFetching}
              className={'min-w-auto'}
              placeholder={'Select a country'}
              value={field.value?.toString()}
              setValue={(val) =>
                setValue('country_id', parseInt(val), {
                  shouldValidate: true,
                })
              }
              options={countries}
            />
          </FormItem>
        )
      }}
    />
  )
}
